import {AnimatePresence, motion} from "framer-motion";
import classes from "../../MergedPatterns/MergedPattern.module.css";
import {getDisplayName} from "../../../utils/utils";
import {formatDate} from "../../../utils/dateUtils";
import React from "react";

const EditHistoryDetails = ({component, keyStr, isActive, openUserModal}) => {

    return <AnimatePresence exitBeforeEnter>
        {isActive &&
            <motion.div
                key={keyStr}
                initial={{opacity: 0, transition: {
                        duration: 0.5, ease: "easeInOut"
                    }}}
                animate={{opacity: 1, transition: {
                    duration: 0.5, ease: "easeInOut"
                }}}
                exit={{opacity: 0, transition: {
                        duration: 0.5, ease: "easeInOut"
                    }}}
            >
                <AnimatePresence exitBeforeEnter>
                    <motion.div
                        animate={{opacity: 1}}
                        initial={{opacity: 0}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.25, ease: "easeInOut"}}
                        key={component.history_id}
                    >
                        <div style={{paddingTop: 5, display: "inline-flex", justifyContent: "end", width: "100%", whiteSpace: "break-spaces"}}>
                            <p style={{marginBottom: 0}}>Edit made by {!component.editor_user_id
                                ? <>a Pattern Author</>
                                : <b className={classes.Link} onClick={() => {
                                    openUserModal();
                                }}>
                                    {getDisplayName(component.display_name, component.first_name, component.last_name)}
                                </b>} on {formatDate(component.edited_timestamp, "dateTime")}.
                            </p>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </motion.div>}
        {/*The following line is used to prevent the div containing this component from shifting when it deactivates*/}
        {!isActive && <div style={{color: "rgba(0,0,0,0)"}}>.</div>}
    </AnimatePresence>

}

export default EditHistoryDetails;